class FastAnchors extends HTMLElement {
  connectedCallback() {
    this.stickyHeaderSelector = this.getAttribute('sticky-header-selector');
    this.addEventListener('click', this.handleClick.bind(this));
  }

  getStickyHeaderHeight() {
    if (!this.stickyHeaderSelector) return 0;
    const header = document.querySelector(this.stickyHeaderSelector);
    return header ? header.offsetHeight : 0;
  }

  handleClick(e) {
    const anchor = e.target.closest('.anchor');
    if (!anchor || !this.contains(anchor)) return;

    const targetSelector = anchor.dataset.target;
    if (!targetSelector) return;

    const target = document.querySelector(targetSelector);
    if (!target) return;

    // Optionally open details/summary
    if (anchor.dataset.openDetails !== undefined) {
      const details = target.querySelector('details');
      const summary = target.querySelector('summary');
      if (details) details.setAttribute('open', 'true');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    // Calculate offset
    let offset = this.getStickyHeaderHeight();
    if (anchor.dataset.offset) {
      offset += parseInt(anchor.dataset.offset, 10) || 0;
    }

    // Scroll
    const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

if (!window.customElements.get('fast-anchors')) {
  window.customElements.define('fast-anchors', FastAnchors);
}